document.addEventListener('DOMContentLoaded', function() {
  // Seleccionar todos los enlaces con href="#modal-opener-button"
  var modalOpeners = document.querySelectorAll('a[href="#modal-opener-button"]');

  // Recorrer todos los botones y agregar el evento de click
  modalOpeners.forEach(function(opener) {
    opener.addEventListener('click', function(event) {
      event.preventDefault();  // Evitar el comportamiento predeterminado del enlace
      var bannerContainer = document.querySelector('.banner-overlay');
      bannerContainer.style.display = 'flex';
      document.body.classList.add('overflow-hidden');
    });
  });

  // Cerrar el modal y activar el scroll al hacer clic en el botón con clase .modal-close
  document.querySelector('.modal-close').addEventListener('click', function() {
      console.log("click");  // Debe salir "click" en la consola si funciona
      var bannerContainer = document.querySelector('.banner-overlay');
      bannerContainer.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
  });
});
